module.exports = __webpack_public_path__ + "static/media/back-arrow.d2074712.svg";